import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login_page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "login_image" }, null, -1)
const _hoisted_3 = { class: "login_form" }
const _hoisted_4 = { class: "p-mb-3" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "p-grid" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-col-3",
  style: {"text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/layout/images/login/icon-login.svg",
    alt: "avalon-vue"
  })
], -1)
const _hoisted_8 = {
  class: "p-col-9",
  style: {"text-align":"left"}
}
const _hoisted_9 = { class: "welcome-text" }
const _hoisted_10 = { class: "guest-sign-in" }
const _hoisted_11 = {
  class: "p-col-12",
  style: {"text-align":"left"}
}
const _hoisted_12 = { class: "login_label" }
const _hoisted_13 = { class: "login_input" }
const _hoisted_14 = {
  class: "p-col-12",
  style: {"text-align":"left"}
}
const _hoisted_15 = { class: "login_label" }
const _hoisted_16 = { class: "login_input" }
const _hoisted_17 = { class: "p-col-12 login_form__actions" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-12 p-md-6 button-pane" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-12 p-md-6 link-pane" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_VField = _resolveComponent("VField")!
  const _component_VI18nError = _resolveComponent("VI18nError")!
  const _component_VError = _resolveComponent("VError")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VForm = _resolveComponent("VForm")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _createElementVNode("img", {
          alt: "Logo",
          src: '/assets/layout/images/' + _ctx.getLogo(),
          width: "400"
        }, null, 8, _hoisted_5)
      ]),
      _createVNode(_component_VForm, {
        onSubmit: _ctx.doLogin,
        autocomplete: "nope",
        as: "form"
      }, {
        default: _withCtx(({ isSubmitting, meta: { valid } }) => [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("h2", _hoisted_9, null, 512), [
                [_directive_t, 'login.title']
              ]),
              _withDirectives(_createElementVNode("span", _hoisted_10, null, 512), [
                [_directive_t, 'login.subtitle']
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("label", _hoisted_12, null, 512), [
                [_directive_t, 'login.username_label']
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_VField, {
                  name: "username",
                  modelValue: _ctx.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.username = $event)),
                  rules: "required"
                }, {
                  default: _withCtx(({ field, meta: {dirty, valid} }) => [
                    _createVNode(_component_InputText, _mergeProps({ autofocus: "" }, field, {
                      disabled: isSubmitting,
                      class: {'p-invalid': dirty && !valid},
                      placeholder: _ctx.$t('login.username_placeholder')
                    }), null, 16, ["disabled", "class", "placeholder"])
                  ]),
                  _: 2
                }, 1032, ["modelValue"]),
                _createVNode(_component_VI18nError, { name: "username" })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("label", _hoisted_15, null, 512), [
                [_directive_t, 'login.password_label']
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_VField, {
                  name: "password",
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.password = $event)),
                  rules: "required"
                }, {
                  default: _withCtx(({ field, meta: {dirty, valid} }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      autocomplete: "new-password",
                      disabled: isSubmitting,
                      class: {'p-invalid': dirty && !valid},
                      type: "password",
                      placeholder: _ctx.$t('login.password_placeholder')
                    }), null, 16, ["disabled", "class", "placeholder"])
                  ]),
                  _: 2
                }, 1032, ["modelValue"]),
                _createVNode(_component_VI18nError, { name: "password" })
              ])
            ]),
            _createVNode(_component_VError, { name: "name" }),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_Button, {
                label: "Sign In",
                type: "submit",
                disabled: !valid || isSubmitting
              }, null, 8, ["disabled"]),
              _createVNode(_component_router_link, {
                class: "p-link",
                to: {name: _ctx.forgotPasswordRoute}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('login.forget_pwd')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _hoisted_18,
            _hoisted_19
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}